import { render, staticRenderFns } from "./3dbar.vue?vue&type=template&id=c63f6588&scoped=true&"
import script from "./3dbar.vue?vue&type=script&lang=js&"
export * from "./3dbar.vue?vue&type=script&lang=js&"
import style0 from "./3dbar.vue?vue&type=style&index=0&id=c63f6588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f6588",
  null
  
)

export default component.exports